import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from "@material-ui/core";
import { IFilaEsperaPagedResponse } from "models/response/fila-espera-paged-response";
import { PaginationResponse } from "models/pagination-response";

type FilasEsperaTableProps = {
    currentItems: PaginationResponse<IFilaEsperaPagedResponse>;
};

const STATUS_LABEL: Record<number, string> = {
    1: 'Aguardando',
    2: 'Atendido/Matriculado',
    3: 'Cancelado'
};

export const FilasEsperaTable: React.FC<FilasEsperaTableProps> = ({ currentItems }) => {
    if (!currentItems?.hasItems()) {
        return <Typography variant="body1">Nenhum registro de fila de espera encontrado.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Tipo de Fila</TableCell>
                        <TableCell>Unidade</TableCell>
                        <TableCell align="right">Vagas Totais</TableCell>
                        <TableCell align="right">Matriculados</TableCell>
                        <TableCell align="right">Quantidade Aguardando</TableCell>
                        <TableCell align="right">Tempo Médio de Espera (dias)</TableCell>
                        <TableCell>Canal de Contato</TableCell>
                        <TableCell>Última Atualização</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentItems.items.map((item) => {
                        const isCreche = (item.tipoFilaEsperaName || '').toLowerCase() === 'creche';
                        const entradas = item.entradas || [];
                        return (
                            <React.Fragment key={item.id}>
                                <TableRow>
                                    <TableCell>{item.tipoFilaEsperaName}</TableCell>
                                    <TableCell>{item.nomeUnidade || 'Não especificado'}</TableCell>
                                    <TableCell align="right">{item.quantidadeVagasTotais ?? '-'}</TableCell>
                                    <TableCell align="right">{item.quantidadeMatriculados ?? '-'}</TableCell>
                                    <TableCell align="right">{item.quantidadeAguardando}</TableCell>
                                    <TableCell align="right">{item.tempoMedioEsperaDias ?? '-'}</TableCell>
                                    <TableCell>{item.desCanalContato || '-'}</TableCell>
                                    <TableCell>{new Date(item.dtaAtualizacao).toLocaleDateString('pt-BR')}</TableCell>
                                </TableRow>
                                {isCreche && (
                                    <TableRow>
                                        <TableCell colSpan={8} style={{ backgroundColor: '#fafafa' }}>
                                            <Typography variant="subtitle2" gutterBottom>
                                                Lista de espera ordenada (identificada apenas por número de protocolo)
                                            </Typography>
                                            {entradas.length === 0 ? (
                                                <Typography variant="body2">Nenhuma entrada cadastrada nesta fila.</Typography>
                                            ) : (
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Posição</TableCell>
                                                            <TableCell>Nº Protocolo</TableCell>
                                                            <TableCell>Status</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {entradas
                                                            .slice()
                                                            .sort((a, b) => a.numeroPosicao - b.numeroPosicao)
                                                            .map((entrada) => (
                                                                <TableRow key={entrada.id}>
                                                                    <TableCell>{entrada.numeroPosicao}</TableCell>
                                                                    <TableCell>{entrada.numeroProtocolo}</TableCell>
                                                                    <TableCell>{STATUS_LABEL[entrada.indStatus] || '-'}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                    </TableBody>
                                                </Table>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </React.Fragment>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
